
import * as TablerIcons from "@tabler/icons-react";

export const Tabler = TablerIcons;

// Optional safety component (for dynamic icon names)
export const SafeIcon = ({ name = "IconQuestionMark", size = 18, stroke = 1.5, className, ...rest }) => {
  const IconComp = TablerIcons[name] || TablerIcons.IconQuestionMark;
  return <IconComp size={size} stroke={stroke} className={className} {...rest} />;
};
